import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { toast } from 'vue3-toastify';

import type { InstallationMonorepo } from '~/services/installation-monorepo/installation-monorepo.types';

import installationMonorepoApi from '~/services/installation-monorepo/installation-monorepo';

import { installationBypassQueryKey } from './useInstallationBypass';

type SaveInstallationBypassParams = InstallationMonorepo.CreateParams & { isUpdate?: boolean };

export default function useCreateInstallationBypass() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ partnerId, payload }: SaveInstallationBypassParams) => installationMonorepoApi.create({
      partnerId,
      payload,
    }),
    onError: (error: any) => {
      const status = error?.response?.status;
      const apiMessage = error?.response?.data?.message || error?.response?.data?.detail;

      if (status === 409) {
        toast.error(
          'Conflito ao salvar, outra atualização está em andamento para este parceiro. Tente novamente.',
        );
        return;
      }

      const errorMessages = {
        401: 'Não autorizado. Faça login novamente.',
        403: 'Sem permissão para executar esta ação.',
      } as const;

      const errorMessage = errorMessages[status as keyof typeof errorMessages]
        || apiMessage
        || 'Erro inesperado ao salvar bypass de instalação.';

      toast.error(errorMessage);
    },
    onSuccess: (_data, variables) => {
      toast.success(
        variables.isUpdate
          ? 'Bypass de instalação atualizado com sucesso!'
          : 'Bypass de instalação criado com sucesso!',
      );
      queryClient.invalidateQueries({
        queryKey: installationBypassQueryKey(variables.partnerId),
      });
    },
    retry: false,
  });
}
